/**
 * This file contains all analytics events for the Meter Explorer.
 */
export enum MeterExplorerEvents {
	TabChanged = 'Meter Explorer: Tab visited',
	ModalOpened = 'Meter Explorer: Modal opened',
	MeterClicked = 'Meter Explorer: Meter clicked',
	FilterApplied = 'Meter Explorer: Filter applied',
	TreemapViewChanged = 'Meter Explorer: Treemap view changed',
	PageNumberChanged = 'Meter Explorer: Page number changed',
	PageSizeChanged = 'Meter Explorer: Page size changed',
	OrderByApplied = 'Meter Explorer: Order by applied',
	MetricMetadataUpdated = 'Meter Explorer: Metric metadata updated',
	OpenInExplorerClicked = 'Meter Explorer: Open in explorer clicked',
	InspectViewChanged = 'Meter Explorer: Inspect view changed',
	InspectQueryChanged = 'Meter Explorer: Inspect query changed',
	InspectPointClicked = 'Meter Explorer: Inspect point clicked',
	QueryBuilderQueryChanged = 'Meter Explorer: QueryBuilder query changed',
	YAxisUnitApplied = 'Meter Explorer: Y axis unit applied',
	AddToAlertClicked = 'Meter Explorer: Add to alert clicked',
	AddToDashboardClicked = 'Meter Explorer: Add to dashboard clicked',
	SaveViewClicked = 'Meter Explorer: Save view clicked',
	SearchApplied = 'Meter Explorer: Search applied',
	ViewEdited = 'Meter Explorer: View edited',
	ViewDeleted = 'Meter Explorer: View deleted',
}

export enum MeterExplorerEventKeys {
	Tab = 'tab',
	Modal = 'modal',
	View = 'view',
	Interval = 'interval',
	ViewType = 'viewType',
	PageNumber = 'pageNumber',
	PageSize = 'pageSize',
	ColumnName = 'columnName',
	Order = 'order',
	AttributeKey = 'attributeKey',
	AttributeValue = 'attributeValue',
	MetricName = 'metricName',
	InspectView = 'inspectView',
	TimeAggregationOption = 'timeAggregationOption',
	TimeAggregationInterval = 'timeAggregationInterval',
	SpaceAggregationOption = 'spaceAggregationOption',
	SpaceAggregationLabels = 'spaceAggregationLabels',
	OneChartPerQueryEnabled = 'oneChartPerQueryEnabled',
	YAxisUnit = 'yAxisUnit',
	ViewName = 'viewName',
	Filters = 'filters',
	TimeRange = 'timeRange',
}
